/* file size in Kb */
export const FILE_SIZE={
  FILE:15000000, // 15 mb
  IMAGE:15000000, // 15 mb
}
